import React, { useState } from 'react'
import { Sidebar } from './Sidebar'
import { Header } from './Header'

interface LayoutProps {
  user?: {
    name: string
    email: string
    avatar?: string
    role: 'admin' | 'user'
  }
  onLogout: () => void
  children: React.ReactNode
}

export function Layout({ user, onLogout, children }: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  return (
    <div className="min-h-screen bg-background">
      {/* Main Layout Container */}
      <div className="flex min-h-screen">
        {/* Sidebar */}
        <Sidebar
          isCollapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
          userRole={user?.role === 'admin' ? 'admin' : 'user'}
        />
        {/* Main Content Area */}
        <div className="flex min-w-0 flex-1 flex-col">
          {/* Header */}
          <Header user={user} onLogout={onLogout} />

          {/* Page Content */}
          <main className="flex-1 bg-gray-50">
            <div className="p-6">{children}</div>
          </main>
        </div>
      </div>
    </div>
  )
}
